import { wellKnown } from "@tc/cognito-pool"
import { DeploymentStage, isDeploymentStage, stage } from "@tc/env-stage"

enum DfeWebAppDomain {
  dev = "https://dev.tradecert.mpi.govt.nz",
  tst1 = "https://test1.tradecert.mpi.govt.nz",
  tst2 = "https://test2.tradecert.mpi.govt.nz",
  prd = "https://tradecert.mpi.govt.nz",
}

enum DfeB2CLogoutUrl {
  tst2 = "https://b2cst.b2clogin.com/b2cst.onmicrosoft.com/oauth2/v2.0/logout",
}

//b2c policy name
export const b2cPolicyName = "b2c_1a_mpi_010_rp_oidc"
export const mpiWebsite = "https://www.mpi.govt.nz"

// ONE Cognito for dev/tst1
export const AWS_USER_POOLS_WEB_CLIENT_ID = "bst9h1nvjcjqd2aaq9cpj2jcp"

// Cognito for tst2
export const AWS_USER_POOLS_WEB_CLIENT_TST2_ID = "2ge4sbihkg1np718vbgr8qb540"

// Cognito for Prod
export const AWS_USER_POOLS_WEB_CLIENT_PROD_ID = "16ejobeukp3aptmh9vmathqdrr"

const AwsUserPoolsWebClientId: Record<DeploymentStage, string> = {
  dev: AWS_USER_POOLS_WEB_CLIENT_ID,
  tst1: AWS_USER_POOLS_WEB_CLIENT_ID,
  tst2: AWS_USER_POOLS_WEB_CLIENT_TST2_ID,
  prd: AWS_USER_POOLS_WEB_CLIENT_PROD_ID,
}

/**
 * Redshield domain name for current stage.
 */
export const authDomain = (): string => {
  if (isDeploymentStage(stage)) {
    return DfeWebAppDomain[stage]
  } else {
    throw new Error(`Unrecognised stage ${stage}`)
  }
}

/**
 * Cognito app client id.
 */
export function appClientId(): string {
  if (isDeploymentStage(stage)) {
    return AwsUserPoolsWebClientId[stage]
  } else {
    throw new Error(`Unrecognised stage ${stage}`)
  }
}

export const serverSideLogoutUrl = async () => {
  const wk = await wellKnown()
  // let logoutUrl = `${process.env.NEXTAUTH_URL || authDomain()}/signout`
  let logoutUrl = mpiWebsite
  if (stage === "tst2") {
    const b2cLogoutQuery = `p=${b2cPolicyName}&post_logout_redirect_uri=${logoutUrl}`
    logoutUrl = `${DfeB2CLogoutUrl.tst2}?${b2cLogoutQuery}`
  }
  const query = new URLSearchParams({
    client_id: appClientId(),
    logout_uri: logoutUrl,
  })
  return `${wk.end_session_endpoint}?${query}`
}

// found in cognito user pool -> federation -> identity providers
// for MPI Azure AD
export const internalIdp = "mpi-azure-ad"

// for dev/tst1
export const externalIdp = "B2c-Sandbox-sysintegrate"

// for tst2
export const externalIdpTest2 = "mpi-b2c-nonprod"

export const internalIdProvider = (): string => {
  if (isDeploymentStage(stage)) {
    return internalIdp
  } else {
    throw new Error(`Unrecognised stage ${stage}`)
  }
}
export const externalIdProvider = (): string => {
  if (isDeploymentStage(stage)) {
    return stage === "tst2" ? externalIdpTest2 : externalIdp
  } else {
    throw new Error(`Unrecognised stage ${stage}`)
  }
}
